<svg width="50" height="50">
    <g transform="rotate(-90 25 25)">
        <path class="settings-tile-svg-fill tile__svg-fill"
              [attr.d]="circlePathBg"
              [attr.fill-opacity]="0.3" stroke="none">
        </path>
        <path class="settings-tile-svg-fill tile__svg-fill"
              [attr.d]="circlePath"
              fill-opacity="1" stroke="none">
        </path>
    </g>
    <path d="M23,25 L 25,0 L27,25 Z" stroke="none" fill="#000"
          [attr.transform]="'rotate(' + value + ', 25,25)'">
    </path>
    <circle cx="25" cy="25" r="3" stroke="none" fill="#000"></circle>
</svg>
